export const casingOdOptions = [
    {
        id: "1",
        name: '4-1/2 " (114.3 mm)',
    },
    {
        id: "2",
        name: '5 " (127.0 mm)',
    },
    {
        id: "3",
        name: '5-1/2 " (139.7 mm)',
    },
    {
        id: "4",
        name: '5-3/4 " (146.05 mm)',
    },
];
export const yesNo = [
    { id: "1", name: "Yes" },
    { id: "0", name: "No" },
  ];
export const supplyPower=[
    {
        id:"1",
        name:"Distribution"
    },
    {
        id:"2",
        name:"Generator"
    }
]
export const controller=[
    {
        id:"1",
        name:"Soft-Start"
    },
    {
        id:"2",
        name:"SWB"
    },
    {
        id:"3",
        name:"VSD"
    }

]

export const casingWeightsOptions = [
    {
        id: "1",
        name: "9.5 lb/ft (14.14 kg/m)",
    },
    {
        id: "2",
        name: "10.5 lb/ft (15.63 kg/m)",
    },
    {
        id: "3",
        name: "11.6 lb/ft (17.26 kg/m)",
    },
    {
        id: "4",
        name: "13.5 lb/ft (20.09 kg/m)",
    },
];

export const tubingOdOptions = [
    {
        id: "1",
        name: '1 " (25.4 mm)',
    },
    {
        id: "2",
        name: '1-1/4 " (31.75 mm)',
    },
    {
        id: "3",
        name: '1-1/2 " (38.1 mm)',
    },
    {
        id: "4",
        name: '2 " (50.8 mm)',
    },
    {
        id: "4",
        name: '2.063 " (52.4 mm)',
    },
];

export const tubingTypeOptions = [
    {
        id: "1",
        name: "Non-Upset",
    },
    {
        id: "2",
        name: "Upset",
    },
];

export const tubingWeightOptions = [
    {
        id: "1",
        name: "1.7 lb/ft (2.53 kg/m)",
    },
];

export const wellTrajectoryOptions = [
    {
        id: "1",
        name: "Vertical",
    },
    {
        id: "2",
        name: "Directional",
    },
];
